import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "academic",
  inputs: [
    {
      label: "Class 10 completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: true,
      fields: [
        {
          name: "class10_score",
          label: "Matriculation Marks",
          placeholder: "8.5 CGPA on scale of 10",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description:
          //   "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "class10_yop",
          label: "Year of Passing",
          placeholder: "2018",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class10_school",
          label: "Matriculation School",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class10_board",
          label: "Matriculation Board",
          placeholder: "CBSE",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Diploma completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "diploma_score",
          label: "Diploma Marks",
          placeholder: "8.5 CGPA on scale of 10",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          //   description:
          //    "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "diploma_yop",
          label: "Year of Passing",
          placeholder: "2018",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "diploma_school",
          label: "From which institution you had completed diploma?",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "diploma_subject",
          label: "In which field you had completed diploma?",
          placeholder: "Computer Science",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
    {
      label: "Class 12 completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "class12_score",
          label: "Class 12 Marks",
          placeholder: "92%",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description:
          //  "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "class12_yop",
          label: "Class 12 Year of Passing",
          placeholder: "2020",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class12_school",
          label: "Class 12 School",
          placeholder: "",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class12_board",
          label: "Class 12 Board",
          placeholder: "CBSE",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "class12_subject",
          label: "Class 12 Subjects",
          placeholder: "Non-Medical",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          //   description:
          //    "Mention the stream choosen after matriculation for e.g.-Arts,Commerce,Medical,Non-Medical etc.",
        },
      ],
    },
    {
      label: "Bachelors completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "bachelors_cgpa",
          label: "Bachelors Marks",
          placeholder: "8 SGPA on scale of 10",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
          // description:
          //  "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "bachelors_yop",
          label: "Year of Passing",
          placeholder: "2023",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "bachelors_university",
          label: "University",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "bachelors_course",
          label: "Course",
          placeholder: "Btech. Computer Science",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "bachelors_core_subjects",
          label: "Bachelors Core Subjects",
          type: InputType.CountedTextArea,
          minLength: 2,
          maxLength: 250,
          assistance: true,
          inputDependencies: ["bachelors_course"],
          helpType: "core_subjects",
        },
      ],
    },

    {
      label: "Masters completed ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "masters_cgpa",
          label: "Masters Marks",
          placeholder: "8 CGPA",
          type: InputType.CountedTextInput,
          minLength: 1,
          maxLength: 100,
          // description:
          //  "If using GPA, please mention like this, '8.5 on scale of 10'",
        },
        {
          name: "masters_yop",
          label: "Year of Passing",
          placeholder: "2023",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "masters_university",
          label: "University",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "masters_course",
          label: "Course",
          placeholder: "Masters Of Technology in Artifical Intelligence",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
        {
          name: "masters_core_subjects",
          label: "Masters Core Subjects",
          type: InputType.CountedTextArea,
          minLength: 2,
          maxLength: 250,
          assistance: true,
          inputDependencies: ["masters_course"],
          helpType: "core_subjects",
        },
      ],
    },

    {
      name: "name_of_test_taken",
      label: "International Language Test Given",
      placeholder: "IELTS",
      required: true,
      type: InputType.CountedAutoComplete,
      minLength: 2,
      maxLength: 100,
      options: [
        "IELTS",
        "Duolingo (DET)",
        "TOEFL (iBT)",
        "Pearson (PTE Academic)",
      ],
    },
    {
      name: "overall_score",
      label: "Overall Test Score",
      placeholder: "7.5",
      type: InputType.CountedTextInput,
      minLength: 1,
      maxLength: 100,
    },
    {
      name: "individual_test_score",
      label: "Individual Test Score",
      placeholder: "Listening-8 Reading-7 Writing-8.5 Speaking-7.5",
      type: InputType.LanguageScoreInput,
      minLength: 1,
      maxLength: 100,
    },

    {
      label: "Any Gap ?",
      type: InputType.InputCluster,
      cols: 2,
      required: false,
      fields: [
        {
          name: "gap_time_period",
          label: "Time Duration Of Gap",
          placeholder: "2 years",
          type: InputType.CountedAutoComplete,
          minLength: 1,
          maxLength: 100,
          options: ["1 year", "2 years", "3 years"],
        },
        {
          name: "gap_explanation",
          label: "Reason for Gap",
          placeholder: "Preparing for GATE",
          type: InputType.CountedTextInput,
          minLength: 2,
          maxLength: 100,
        },
      ],
    },
  ],
};

export default formFields;
